const askEnum = Object.freeze({
    YES: 5,
    NO: 10
});
export default askEnum;
